import React from 'react';
import { Scale, Cpu, Users } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useLanguage } from '@/contexts/LanguageContext';

export const ExpertiseSection = () => {
  const { language } = useLanguage();

  const expertise = [
    {
      icon: Scale,
      title: language === 'fr' ? 'Pratique juridique' : 'Legal practice',
      description: language === 'fr'
        ? 'Des avocats qui comprennent les workflows, les contraintes déontologiques et les défis quotidiens de la profession.'
        : 'Lawyers who understand legal workflows, ethical constraints, and the daily challenges of the profession.',
    },
    {
      icon: Cpu,
      title: language === 'fr' ? 'Expertise tech' : 'Tech expertise',
      description: language === 'fr'
        ? 'Des profils tech qui maîtrisent l\'IA générative et conçoivent des solutions adaptées aux besoins des cabinets.'
        : 'Tech specialists who master generative AI and design solutions tailored to law firm needs.',
    },
    {
      icon: Users,
      title: language === 'fr' ? 'Vision commune' : 'Shared vision',
      description: language === 'fr'
        ? 'Une équipe qui imagine les solutions rendant aux avocats la maîtrise de leurs tâches grâce à l\'IA.'
        : 'A team designing solutions that give lawyers back control over their tasks through AI.',
    },
  ];

  return (
    <section className="relative py-20 overflow-hidden hero-bg">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            {language === 'fr' ? 'Notre expertise' : 'Our expertise'}
          </h2>
          <p className="text-lg text-muted-foreground">
            {language === 'fr'
              ? 'Notre expérience mêle compétences d\'avocats et profils tech pour imaginer les solutions qui vous rendent la maîtrise de vos tâches.'
              : 'Our experience combines lawyer and tech expertise to design solutions that give you back control over your tasks.'
            }
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {expertise.map((item, index) => (
            <Card key={index} className="glass-card border-t-4 border-t-primary hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
              <CardHeader>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-xl gradient-bg flex items-center justify-center">
                    <item.icon className="w-6 h-6 text-primary-foreground" />
                  </div>
                  <CardTitle className="text-lg text-foreground">{item.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base text-muted-foreground">
                  {item.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
